import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientname: {
      validations: []
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    eventextra8: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name: *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name: *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name / Organization:',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State:',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal:',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number: *',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'E-mail Address: *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event:',
            mapping: 'theme'
          },          
          {
            type: 'date-picker',
            size: 'XLarge',
            label: 'Desired Event Date (MM/DD/YYYY): *',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How did you hear about us?: *',
            mapping: 'eventextra8'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Event Information:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please wait for the confirmation page to appear before closing your browser.',
            mapping: 'headerLabel'
          }
        ]
      },
    ]
  },
  info: {
    title: 'Roger Williams Zoo Contact Form',
    formId: '667',
    clientKey: 'C203CB01-0F84-4C49-8F87-3A1B86F0223B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/rogerwilliamszoo/form_structure.js